export default "__VITE_ASSET__SO5pWO26__"